import { Injectable } from '@angular/core';
import { NotificationIdentifierModel, NotificationModel, NotificationService } from '@evorait/pace-core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class NotificationResolver implements Resolve<NotificationModel> {
    public constructor(private readonly notificationService: NotificationService) {}

    public resolve(route: ActivatedRouteSnapshot): NotificationModel {
        const id = new NotificationIdentifierModel(
            route.paramMap.get('frontid') || '',
            route.paramMap.get('qmnum') || '',
            route.paramMap.get('manum') || '',
        );
        const notification = this.notificationService.getNotificationByIdentifier(id);
        if (typeof notification === 'undefined') {
            throw new Error(
                `Could not load notification for frontId '${id.frontId}', qmNum '${id.qmNum}', maNum '${id.maNum}'`,
            );
        }
        return notification;
    }
}
